<template>
  <div class="animated fadeIn">

    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3" v-if="can('horaires-edit')">
          <router-link :to="'/plannings/heures_ouvertures/parametrage'">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-edit"></i>&nbsp;Editer
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-modal ref="myModalRef" hide-footer centered title="Paramétrage des heures d'ouverture">
        <div class="d-block text-center">
          <p style>Aucun horaire de travail effectué sur l'entité !</p>
          <h5>Vous devez paramétrer des horaires de travail.</h5>
        </div>
        <!-- <b-btn class="mt-3 col-lg-6" variant="outline-danger" style="max-width: 100%;">Annuler</b-btn>-->
        <router-link :to="'/plannings/heures_ouvertures/parametrage'">
          <b-btn class="mt-3 col-lg-6" v-if="can('horaires-create')" variant="outline-success" style="max-width: 100%;">Paramétrer</b-btn> 
        </router-link>
      </b-modal>
    </b-card-body>
    <b-row v-if="bool_horaire">
     <b-col lg="12">
          <div class="table100 ver2 m-b-110">
					<table data-vertable="ver2">
						<thead>
							<tr class="row100 head">
								<th class="column100 column1" data-column="column1"></th>
								<th class="column100 column2" data-column="column2">Ouvert / Fermé</th>
								<th class="column100 column3" data-column="column3">Heure d'ouverture</th>
								<th class="column100 column4" data-column="column4">Heure de fermeture</th>
								
							</tr>
						</thead>
						<tbody>
							<tr class="row100">
								<td class="column100 column1" data-column="column1">{{ events[1].jour }}</td>
								<td class="column100 column2" data-column="column2">{{ events[1].ouvert }}</td>
								<td class="column100 column3" data-column="column3">{{ events[1].heure_ouverture }}</td>
								<td class="column100 column4" data-column="column4">{{ events[1].heure_fermeture }}</td>
							
							</tr>

							<tr class="row100">
								<td class="column100 column1" data-column="column1">{{ events[2].jour }}</td>
								<td class="column100 column2" data-column="column2">{{ events[2].ouvert }}</td>
								<td class="column100 column3" data-column="column3">{{ events[2].heure_ouverture }}</td>
								<td class="column100 column4" data-column="column4">{{ events[2].heure_fermeture }}</td>
							
							</tr>

							<tr class="row100">
								<td class="column100 column1" data-column="column1">{{ events[3].jour }}</td>
								<td class="column100 column2" data-column="column2">{{ events[3].ouvert }}</td>
								<td class="column100 column3" data-column="column3">{{ events[3].heure_ouverture }}</td>
								<td class="column100 column4" data-column="column4">{{ events[3].heure_fermeture }}</td>
							
							</tr>

							<tr class="row100">
								<td class="column100 column1" data-column="column1">{{ events[4].jour }}</td>
								<td class="column100 column2" data-column="column2">{{ events[4].ouvert }}</td>
								<td class="column100 column3" data-column="column3">{{ events[4].heure_ouverture }}</td>
								<td class="column100 column4" data-column="column4">{{ events[4].heure_fermeture }}</td>
							
							</tr>

							<tr class="row100">
								<td class="column100 column1" data-column="column1">{{ events[5].jour }}</td>
								<td class="column100 column2" data-column="column2">{{ events[5].ouvert }}</td>
								<td class="column100 column3" data-column="column3">{{ events[5].heure_ouverture }}</td>
								<td class="column100 column4" data-column="column4">{{ events[5].heure_fermeture }}</td>
							
							</tr>

							<tr class="row100">
								<td class="column100 column1" data-column="column1">{{ events[6].jour }}</td>
								<td class="column100 column2" data-column="column2">{{ events[6].ouvert }}</td>
								<td class="column100 column3" data-column="column3">{{ events[6].heure_ouverture }}</td>
								<td class="column100 column4" data-column="column4">{{ events[6].heure_fermeture }}</td>
								
							</tr>

							<tr class="row100">
								<td class="column100 column1" data-column="column1">{{ events[0].jour }}</td>
								<td class="column100 column2" data-column="column2">{{ events[0].ouvert }}</td>
								<td class="column100 column3" data-column="column3">{{ events[0].heure_fermeture }}</td>
								<td class="column100 column4" data-column="column4">{{ events[0].heure_fermeture }}</td>
							
							</tr>

							
						</tbody>
					</table>
				</div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/locale/fr'
import api from '../../../api/';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  //components: {VueGoodTable},
  components: {FullCalendar},
   data(){
    return {
      config: {
        locale: 'fr',
      },
      bool_horaire:false,
      events: [],
      columns: [
        {
          label: 'Montant minimal',
          field: 'montant_min',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant maximal',
          field: 'montant_max',
          filterable: true,width: '180px',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Tarif',
          field: 'tarif',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'DD-MM-YYYY',
          filterable: true,width: '180px',
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Enregistré le',
          field: 'created_at',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'DD-MM-YYYY',
          formatFn: this.formatFn,
          filterable: true,width: '180px',
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 3,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search:{
            enabled: false,
            trigger: 'keyup',
            placeholder: 'Rechercher dans la table',
        },
        entite_id:''
    };
  },
  // computed: mapState({
  //   agencies: state => state.atm.all
  // }),
  created () {
    
    //this.get_all_planning()
  },
  methods:{
    formatFn: function (value) {
        return value != null ? value : null
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    async get_all_planning(){
      let response = await api.entity.get_balance_entites(token)
      this.entite_id = response.data.data.id
      this.response = await this.$store.dispatch('planning/get_all_planning_by_entite',this.entite_id).then((res)=>{
        
        this.events =  store.getters['planning/rows_horaires'];
        
        if (this.events.length>0){
          this.bool_horaire=true
          return this.events
        }else{
          this.bool_horaire=false
          console.log(this.events.length);
          this.$refs.myModalRef.show()
        }
        
      })
     
        //return this.events =  store.getters['planning/rows'];
    }
  },
  mounted(){
    this.get_all_planning()
  }
  
}
</script>
